// Следующая порция истории: дописываем к загруженным, повторы по id отбрасываем
// (новая операция между запросами сдвигает страницы)
export const appendUnique = (loadedItems, nextItems) => {
  const loadedIds = new Set(loadedItems.map((item) => item.id));
  return [
    ...loadedItems,
    ...nextItems.filter((item) => !loadedIds.has(item.id)),
  ];
};
